(function(){
  document.addEventListener('click', function(e){
    var t = e.target.closest('.thumb');
    if (t) {
      var g = t.closest('[data-gallery]');
      var img = g && g.querySelector('.gallery-main img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = t.getAttribute('data-src'); img.alt = t.getAttribute('data-alt') || img.alt; }
      g.querySelectorAll('.thumb').forEach(function(x){ x.classList.toggle('is-active', x === t); });
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = q.parentElement.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-qty'), 10);
      input.value = Math.max(1, Math.min(99, v));
    }
  });
  document.addEventListener('change', function(e){
    var r = e.target;
    if (!r.matches || !r.matches('.buy-form input[name="id"]')) return;
    var f = r.closest('form');
    var p = f.querySelector('[data-price]');
    if (p && r.getAttribute('data-price')) p.textContent = r.getAttribute('data-price');
    var btn = f.querySelector('[name="add"]');
    if (btn) { var ok = r.getAttribute('data-available') === 'true'; btn.disabled = !ok; btn.textContent = ok ? 'Add to cart' : 'Sold out'; }
  });
})();
